import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, Divider,
    Table, TableBody, TableCell, Checkbox, TableRow, TablePagination, TableHead, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@material-ui/core';
import Select from 'react-select';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton'
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';
import { array } from 'prop-types';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
        width: '100%',
        padding: 10,
        margin: 'auto',
        alignItems: 'center',
        alignContent: 'center',
        overflowX: 'auto'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300,
        padding: 5,
    },
})

let id = 0;

class GroupEdit extends Component{
    constructor(props){
        super(props)
        this.state = {
            groups: [],
            rowsPerPage : 10,
            page : 0,
            searchPhrase : '',
            searchPhraseGName: '',
            checkedList : [],
            open2: false
        }
    }

    

    componentDidMount(){
        var groups = []
        var studentArr = []
        db.collection('WorkGroups').orderBy('name', 'asc').get()
        .then( snapshot => { 
            snapshot.forEach( grp => {
                var memberIDs = [];
                var names = [];
                var levels = [];
                try { 
                    console.log('DATA', grp.data())
                    grp.data().Members.forEach( async member => { 
                        if (member.uid){
                            memberIDs.push(member.uid)
                            names.push(member.Name)
                            const userRef = await db.collection('Users').where('UID', '==', member.uid).get()
                            var snapshot = userRef
                            snapshot.forEach( doc => { 
                                console.log('STUDENT', doc.data(), doc.data().CurrentLevel)
                                levels.push(doc.data().CurrentLevel)
                            })
                        }
                        if (member.value){
                            //make the same query but with the updated styling
                            memberIDs.push(member.value)
                            names.push(member.name)
                            const userRef = await db.collection('Users').where('UID', '==', member.value).get()
                            var snapshot = userRef
                            snapshot.forEach( doc => { 
                                console.log('STUDENT', doc.data(), doc.data().CurrentLevel)
                                levels.push(doc.data().CurrentLevel)
                            })
                        }
                    })
                } 
                catch (error) {
                    console.error(error.message)
                }
                
                

                var obj = {
                    uid: grp.id,
                    memberNames: names,
                    memberIDs: memberIDs, 
                    gName: grp.data().name,
                    levels: levels
                }
                groups.push(obj)
            })
            console.log(groups) //testing
            this.setState({
                groups: groups
            })
            
        })

        db.collection('Users').where('accountType', '==', 'Student').get()
        .then(snapshot => {
            var arr = [] 
            snapshot.forEach(doc => { 
                var obj = {
                    
                    label: doc.data().displayName,
                    value: doc.data().UID,
                    name: doc.data().displayName,
                
                }
                studentArr.push(obj)
            })
        })

        this.setState({
            ...this.state,
            open: false,
            checkedList: [],
            students : studentArr,
            selected : [],
            selectedGrp : {},
            rowsPerPage : 10,
            page : 0,
            searchPhrase : '',
            open2: false
        })
    }

    createData(gName, memberNames, levels, uid) {
        id += 1;
        return {id, gName, memberNames, levels, uid}; 
    }

       //ROWS FOR THE TABLE   
       rows = (arr) => {
           console.log('ARR', arr)
        const output = [];
        arr.map(record => {
            output.push(
                this.createData(record.gName, record.memberNames, record.levels, record.uid)
            )
        })
        return output
    }

    searchArr = (arr, searchTerm, GNameSearchTerm) => {
        var searchGroup = false
        var output = [];
        console.log('SEARCHTERM', searchTerm, GNameSearchTerm)
        if (searchTerm == ''){
            searchGroup = true
        }

        if (!searchGroup){
            if (searchTerm.includes(', ')){
                searchTerm = searchTerm.toLowerCase()
                var searchArr = searchTerm.split(', ')
                var count = 0;
                var holdingArr = [];
                // console.log('SEARCH ARR', searchArr)
                arr.forEach( list => {
                    var members = [];
                    count = 0;
                    if (list.memberNames.length > 1){
                        list.memberNames.forEach(n => { 
                            members.push(n.toLowerCase())
                        })
                        // console.log('MEMEBRS', members)
                        searchArr.forEach( name  => {
                            // console.log('wtf is going on', members, name, members.includes(name))
                            if (members.indexOf(name) != -1){
                                count = count + 1
                            }
                        })
                        console.log('COUNT', count, searchArr.length, searchArr, members)
                        if (count == searchArr.length){
                            return output.push(list)
                        }
                    }
                })
                return output
            } else if (searchTerm.includes(' ')) {
                searchTerm = searchTerm.toLowerCase()
                var searchArr = searchTerm.split(' ')
                var count = 0;
                var holdingArr = [];
                // console.log('SEARCH ARR', searchArr)
                arr.forEach( list => {
                    var members = [];
                    count = 0;
                    if (list.memberNames.length > 1){
                        list.memberNames.forEach(n => { 
                            members.push(n.toLowerCase())
                        })
                        // console.log('MEMEBRS', members)
                        searchArr.forEach( name  => {
                            // console.log('wtf is going on', members, name, members.includes(name))
                            if (members.indexOf(name) != -1){
                                count = count + 1
                            }
                        })
                        console.log('COUNT', count, searchArr.length, searchArr, members)
                        if (count == searchArr.length){
                            return output.push(list)
                        }
                    }
                })
                return output
            } else {
                searchTerm = searchTerm.toLowerCase()
                var output = [];
                arr.forEach(e => {
                    // console.log('£', e)
                    e.memberNames.forEach( member => {
                        if (member.toLowerCase().search(searchTerm) != -1 && !output.includes(e)) {
                            return output.push(e)
                        }
                    })
                })
                return output
            }
           
        } else {
            arr.forEach(group => { 
                if (group.gName.toLowerCase().includes(GNameSearchTerm.toLowerCase())){
                    output.push(group)
                }
            })
            // console.log('OUTPUT', output) //Debug
            return output
        }
    }
        
    
        checked = obj => event => {
            console.log(this.state)
            console.log('VALUE', event.target.value, obj)
            const groups = this.state.groups
            console.log('GROUPs', groups)
            var index
            groups.forEach(grp => { 
                if (grp.uid == obj.uid){
                    console.log('BINGO', grp, groups[groups.indexOf(grp)], groups.indexOf(grp))
                    return index = groups.indexOf(grp)
                }
            })
            var selectedGrp = groups[index]
            console.log(selectedGrp)
            this.setState({
                ...this.state,
                checkedList: selectedGrp.uid,
                checkedListCopy: selectedGrp,
                open: true,
                selectedGrp: selectedGrp,
                index: index
            })
        }
    
        checkedAll = () => {
            console.log(this.makeTableData())
        }
    
        handleChange = name => event => {
            if (name == 'searchPhrase'){
                //change the sPhrase and set Gname to ''
                this.setState({
                    ...this.state,
                    [name]: event.target.value,
                    searchPhraseGName: ''
                })
            } else
            if (name == 'searchPhraseGName'){
                //change Gname and set sPhrase to ''
                this.setState({
                    ...this.state,
                    [name]: event.target.value,
                    searchPhrase: ''
                })
            } else {
                //do what we always did
                 this.setState({
                    ...this.state,
                    [name]: event.target.value
                })
            }
        }
        
       
    

    handleClose = () => { 
        this.componentDidMount()
    }

    makeTableData = () => {
        return this.searchArr(this.rows(this.state.groups), this.state.searchPhrase, this.state.searchPhraseGName)
        
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    removeMember = index => { 
        console.log('INDEX', index, this.state.checkedListCopy, this.state.checkedList, this.state.selectedGrp)
        var obj = this.state.checkedListCopy;
        obj.memberNames.splice(index, 1)        
        obj.memberIDs.splice(index, 1)
        console.log(obj)
        this.setState({
            selectedGrp: obj
        })
    }

    deleteSelected = obj => {
        console.log(obj, this.state.selected, obj.uid)
        var groups = this.state.groups
        var selected = this.state.selected
        const docId = obj.uid
        if (obj.gName) { 
            var output = {
                name: obj.gName,
                Members: []
            }
        } else {
            var output = {
                name: '',
                Members: []
            }
        }

        obj.memberNames.forEach(name => { 
            output.Members.push({ Name: name, uid: obj.memberIDs[obj.memberNames.indexOf(name)]})
        })
        selected.forEach(opt => { 
            output.Members.push({ Name: opt.name, uid: opt.value})
        })
        console.log('OUTPUT', output, docId)
        db.collection('WorkGroups').doc(docId).set(output)
        .then(() => {
            window.alert('Changes saved.')
            this.componentDidMount()
        })
    }

    handleEditCheck = (opt, meta)  => {
        console.log('handle Check started')
        console.log(opt, meta)
        var arr = []
        opt.forEach(student => { 
            arr.push(student)
        })
        console.log(arr)
        this.setState({selected: arr})
    }

    deleteGroup = () => {
        console.log(this.state.selectedGrp, this.state.index)
        var index = this.state.index
        var OGgroupList = this.state.groups
        var output = OGgroupList.splice(index, 1)
        console.log(OGgroupList)
        this.setState({
            ...this.state,
            open2 : true,
            open : false,
            groupToDelete: output
        })
    }

    deleteConfirmed = (arr) => { 
        console.log(arr)
        const uid = arr[0].uid
        db.collection('WorkGroups').doc(uid).delete()
        .then( () => { 
            window.alert('Group deleted and changes saved')
            this.componentDidMount()
        })
        .catch(function(err){
            console.error('Error deleting group: ' + err)
            window.alert('There was an error when deleting. Please try again.')
            this.componentDidMount()
        })

    }

    render(){
        const { classes } = this.props;
        return (
            this.state.groups.length > 0 ? 
                <Paper className={classes.root}>
                    <Typography variant='headline'>
                        Edit Student Groups
                    </Typography>
                    <Divider/>
                    <br/>
                    <TextField className={classes.TextField}
                        onChange={this.handleChange('searchPhraseGName')}
                        value={this.state.searchPhraseGName}
                        helperText='Search for Groups via Group Name'
                    />
                    <br/>
                    <TextField className={classes.TextField}
                        onChange={this.handleChange('searchPhrase')}
                        value={this.state.searchPhrase}
                        helperText='Search for Groups via members dislay name(s)'
                    />
                    <br/>
                    <br/>
                    <Paper style={{overflowX: 'auto'}}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell><Checkbox disabled={true}/></TableCell>
                                <TableCell>Group Name</TableCell>
                                <TableCell>Members</TableCell>
                                <TableCell>Group Academic Levels</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.makeTableData()
                                .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                .map(row => {
                                    console.log(row)
                                return (
                                    
                                    <TableRow 
                                        key={row.id}
                                        hover
                                        tabIndex={-1}>
                                        <TableCell><Checkbox  value={row.uid} onChange={this.checked({uid: row.uid, memberNames: row.memberNames})} checked={this.state.checkedList == row.uid}/></TableCell>
                                        <TableCell component="th" scope="row">
                                        {row.gName}
                                        </TableCell>
                                        <TableCell>
                                            {row.memberNames.map(name => { 
                                                name = name + ', '
                                                return name
                                            })}
                                        </TableCell>
                                        <TableCell>
                                            {row.levels.map(level => { 
                                                level = level + ', '
                                                return level
                                            })}
                                        </TableCell>
                                        
                                    </TableRow>
                                    
                                )
                            })}
                            </TableBody>   
                    </Table>
                    <TablePagination
                        component='div'
                        count={this.makeTableData().length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                            'aria-label': 'Next Page',
                            }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                            </Paper>
                        <Dialog
                            open={this.state.open}
                            onClose={this.handleClose}
                            aria-labelledby="form-dialog-title"
                        >
                        <DialogTitle id="form-dialog-title"> Edit Group </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Edit or delete existing user groups and save changes directly to the database. <br/>
                                (press Esc to undo unsaved changes)
                            </DialogContentText>
                        <br/>
                        {/* <Button variant='outlined' onClick={() => this.deleteSelected(this.state.selectedGrp)}>
                                Delete Group
                        </Button>
                        <br/>
                        <br/> */}
                        <Typography variant='subheading'>
                                Group Members
                                <Divider/>
                        </Typography>
                        <br/>
                        {this.state.checkedList.length > 0 ? 
                            this.state.selectedGrp.memberNames.map(name => { 
                                return (
                                    <div style={{width: '100%', margin: 'auto'}}>
                                        <section>
                                            <Typography>
                                                <div>
                                                    <IconButton aria-label='Delete Member' style={{margin: 'auto'}}onClick={()=>{this.removeMember(this.state.selectedGrp.memberNames.indexOf(name))}}>
                                                        <DeleteIcon/>
                                                    </IconButton>
                                                    {name}
                                                </div>
                                            </Typography>
                                        </section>
                                    </div>
                                    
                                )
                            })
                        :
                            <div/>
                        }
                        <br/>
                        <Typography variant='subheading'>
                            Add Members
                            <Divider/>
                        </Typography>
                        <br/>
                        <Select 
                            options={this.state.students} 
                            maxMenuHeight={150}
                            isMulti
                            onChange={(opt, meta) => this.handleEditCheck(opt, meta)}
                            error
                        />
                        </DialogContent>
                        
                        <DialogActions>
                        <Button variant='raised' onClick={() => this.deleteGroup()}>
                                Delete Group
                        </Button>
                            <Button variant='raised' onClick={() => this.deleteSelected(this.state.selectedGrp)}>
                                    Save Changes
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                            open={this.state.open2}
                            onClose={this.handleClose}
                            aria-labelledby="form-dialog-title"
                        >
                        <DialogTitle id="form-dialog-title"> Confirmation </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to delete the following group? This change is permanent.
                            </DialogContentText>
                        <br/>
                        <Typography variant='subheading'>
                                Group Members
                                <Divider/>
                        </Typography>
                        <br/>
                        {this.state.checkedList.length > 0 ? 
                            this.state.selectedGrp.memberNames.map(name => { 
                                return (
                                    <div style={{width: '100%', margin: 'auto'}}>
                                        <section>
                                            <Typography>
                                                <div>
                                                    <IconButton aria-label='Delete Member' style={{margin: 'auto'}}onClick={()=>{this.removeMember(this.state.selectedGrp.memberNames.indexOf(name))}}>
                                                        <DeleteIcon/>
                                                    </IconButton>
                                                    {name}
                                                </div>
                                            </Typography>
                                        </section>
                                    </div>
                                    
                                )
                            })
                        :
                            <div/>
                        }
                        </DialogContent>
                        
                        <DialogActions>
                        <Button variant='raised' onClick={() => this.handleClose()}>
                                No - undo
                        </Button>
                            <Button variant='raised' onClick={() => this.deleteConfirmed(this.state.groupToDelete)}>
                                    Yes - delete
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Paper>
            :
            <div/>
        )
    }
}
export default withStyles(styles)(GroupEdit);


// WEBPACK FOOTER //
// ./src/admin/groupEdit.jsx